import React from 'react';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field, getIn } from 'formik';
import Select from 'react-select';
import classNames from 'classnames';

function FormSelectFieldInner(props) {
  const {
    label,
    placeholder,
    form,
    field,
    options,
    onChangeHandler,
    onInputChange = () => {},
    disabled,
    required = false,
    rawValue = false,
    className,
  } = props;

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const value = (() => {
    if (!field.value) return null;

    if (rawValue) {
      return options.find((opt) => opt.value === field.value) || null;
    }

    if (typeof field.value === 'string') {
      return (
        options.find((opt) => opt.value === field.value) ||
        options.find((opt) => opt.label === field.value) ||
        null
      );
    }

    return field.value;
  })();

  return (
    <Row className={classNames('mb-3', className)}>
      <Col style={{ textAlign: 'left' }}>
        <Label className={classNames(required && 'label-required')}>{label}</Label>
        <FormGroup
          className={classNames((form.submitCount > 0 || touched) && error && 'field-error')}
        >
          <Select
            options={options}
            placeholder={placeholder}
            value={value}
            isDisabled={form.isSubmitting || disabled}
            onBlur={() => form.setFieldTouched(field.name, true)}
            onInputChange={onInputChange}
            onChange={(option) => {
              const newValue = rawValue ? option?.value : option;
              form.setFieldValue(field.name, newValue);
              if (typeof onChangeHandler === 'function') {
                onChangeHandler(newValue);
              }
            }}
            className="select-field"
            classNamePrefix="select-field"
          />
          {(form.submitCount > 0 || touched) && error && (
            <label
              style={{
                display: 'block',
                fontSize: 13,
                fontWeight: 400,
                color: 'red',
                marginTop: 6,
                letterSpacing: '0.02rem',
              }}
            >
              {error?.value ? error.value : error}
            </label>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
}

function FormSelectField(props) {
  return <Field {...props} component={FormSelectFieldInner} />;
}

FormSelectField.defaultProps = {
  placeholder: '',
  options: [],
  onChangeHandler: () => {},
  disabled: false,
};

FormSelectField.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  onChangeHandler: PropTypes.func,
  disabled: PropTypes.bool,
};

export default FormSelectField;
